module.exports = __webpack_public_path__ + "img/energy-technology.abd23aea.svg";